'use client'
import type { StatusType } from '@datadog/browser-logs'

import { getPublicEnvVars } from '@b-stock/fe-core/bstock-next/helpers'
import { ddLogger } from '@b-stock/fe-core/bstock-react'

import { datadogBeforeSend } from '@/helpers/telemetry/datadogBeforeSend'

let needToInit = typeof window !== 'undefined'

const InitBrowserLogger = () => {
  if (!needToInit) return null
  needToInit = false

  const {
    PUBLIC_APP_ENV = 'unknown',
    PUBLIC_BUILD_ID = 'unspecified',
    PUBLIC_DATADOG_CLIENT_TOKEN = '',
    PUBLIC_DATADOG_LOGS,
    PUBLIC_LOG_LEVEL = 'debug',
  } = getPublicEnvVars()

  ddLogger.startLogger({
    appName: 'home-portal',
    datadogConfig: {
      beforeSend: datadogBeforeSend,
      clientToken: PUBLIC_DATADOG_CLIENT_TOKEN,
      forwardConsoleLogs: ['error', 'warn', 'info'],
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      version: PUBLIC_BUILD_ID,
    },
    enabled: !!PUBLIC_DATADOG_LOGS && PUBLIC_DATADOG_LOGS !== 'false',
    env: PUBLIC_APP_ENV,
    level: PUBLIC_LOG_LEVEL as StatusType,
  })

  return null
}

export default InitBrowserLogger
